const ProductListingLevels = [
    'Premium MasterSpec',
    'Premium',
    'Premium Proprietary',
    'Manufacturer',
]

export default ProductListingLevels
